/**
 *@author yudeping
 *对应关系控件
 */

import Component from '../../../lib/component'
import Mediator from '../../../lib/mediator';
import DataTableAgGrid from '../../dataGrid/data-table-page/data-table-agGrid/data-table-agGrid';
import './correspondence-control.scss';
import template from './correspondence-control.html';
import WXtemplate from './correspondence-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';

let config = {
	template: template,
	actions: {
		init(){
			setTimeout(()=>{
                let config = {
                    tableId: this.data.value,
                    parentTableId: this.data.parent_table_id,
                    parentTempId: this.data.temp_id,
                    parentRealId: this.data.parent_real_id,
                    rowId: this.data.parent_temp_id || '',
                    viewMode: 'viewFromCorrespondence',
	                record_id: this.data.recordId || '',
                    correspondenceField: this.data.dfield,
	                fromApprove: this.data.fromApprove,
                }
				if(this.el.find('.correspondence-box').length!=0){
					this.data.dataGrid && this.data.dataGrid._destroy();
					let dataGrid = new DataTableAgGrid({data: config});
					this.data.dataGrid = dataGrid;
					this.append(dataGrid, this.el.find('.correspondence-box'));
					this.hideLoading();
				}
			},0)
		},
		correspondenceDefault(res) {
			if (res == this.data.value) {
				this.data.dataGrid.actions.getGridData();
			}
		}
	},
	binds: [
		{
			event: 'click',
			selector: '.ui-forms-a',
			callback: function () {
				this.events.openCorrespondence(this.data);
			}
		},
	],
	afterRender() {
		this.showLoading();
		this.actions.init();
	},

	firstAfterRender() {
		Mediator.subscribe('form:correspondenceRequired:' + this.data["value"], (res) => {
			if(!this.el){
				return;
			}
			if (!res) {
				this.el.find('#requiredLogo').removeClass().addClass('required');
				this.data.correspondenceHasValue = false;
			} else {
				this.el.find('#requiredLogo').removeClass().addClass('required2');
				this.data.correspondenceHasValue = true;
			}
			this.events.CorrespondenceRequiredChange(this.data);
		})
	},

	beforeDestory() {
		this.el.off();
	}
}
let Correspondence = Component.extend(config)
export default Correspondence
let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		init(){
			let config = {
				tableId: this.data.value,
				parentTableId: this.data.parent_table_id,
				parentTempId: this.data.temp_id,
				parentRealId: this.data.parent_real_id,
				rowId: this.data.parent_temp_id || '',
				viewMode: 'viewFromCorrespondence',
				recordId: this.data.recordId || '',
				correspondenceField: this.data.dfield,
				wxOperate:true
			}
			let dataGrid = new DataTableAgGrid({data: config});
			this.data.dataGrid = dataGrid;
			this.append(dataGrid, this.el.find('.songGrid'));
		},
	}),
	binds:config.binds,
	afterRender(){
		this._super.afterRender();
		this.actions.init();
		this.el.closest('.wxControl-wrap').css('background-color','rgba(255,255,255,.9)')
	},
	beforeDestory:config.beforeDestory,
}
let CorrespondenceWX=BaseControl.extend(WXconfig);
export {CorrespondenceWX}


// WEBPACK FOOTER //
// app/components/form/correspondence-control/correspondence-control.js